module.exports = __webpack_public_path__ + "img/logo_nidv.0308fd5b.png";